<template>
  <v-card flat class="ma-0 pa-0">
    <v-parallax class="hero-image" height="400" src="@/assets/images/login-hero.jpg">
      <v-card-title class="display-2 mb-1">{{ $t('login.title') }}</v-card-title>
    </v-parallax>
    <v-card-title></v-card-title>
    <v-card-text>
      <v-btn color="secondary" @click="login" class="t-login-btn">{{ $t('login.btn-text') }}</v-btn>
    </v-card-text>
    <v-card-text class="body-1"><p v-html="$t('login.info')"></p></v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'Login',

  methods: {
    login() {
      this.$auth.loginWithRedirect()
    },
  }

}
</script>

<style>

</style>